class SearchForm extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  static get requiredElements () {
    return ['input']
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.listeners.add(this.els.input.element, 'click', this.onTriggerClick)
  }

  onTriggerClick () {
    this.isActive = true
  }

  get isActive () {
    return this.hasAttribute('active')
  }

  set isActive (val) {
    val ? this.setAttribute('active', '') : this.removeAttribute('active')

    document.body.classList.toggle('util-SiteOverflowed', val)
  }
}

if (!customElements.get('search-form')) {
  customElements.define('search-form', SearchForm)
}
